// extracted by mini-css-extract-plugin
export default {"cookieConsent":"style_cookieConsent__PXjiE","fadeIn":"style_fadeIn__fKM4J","text":"style_text__QbcX1","link":"style_link__DxSkR","button":"style_button__stUzz"};